import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";

export const Title = ({
  label,
  title,
  placeholderMessage,
  onChange,
  validateForm,
  onFocusElement,
  errors,
  marginTop,
  ...rest
}) => {
  const hasError = errors.length > 0;

  return (
    <>
      <Form.Field size="small" required label={label} id="project-title" marginTop={marginTop}>
        <Form.Input
          size="medium"
          key="name"
          id="one"
          placeholderMessage={placeholderMessage}
          onChange={e => onChange({ name: e.target.value })}
          name="name"
          defaultValue={title}
          validate={validateForm}
          required
          onFocus={onFocusElement}
          hasError={hasError}
          {...rest}
        />
      </Form.Field>

      {hasError && <Form.Error>{errors.join(", ")}</Form.Error>}
    </>
  );
};

Title.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  placeholderMessage: PropTypes.string,
  onChange: PropTypes.func,
  validateForm: PropTypes.func,
  onFocusElement: PropTypes.func,
  errors: PropTypes.array,
  marginTop: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

Title.defaultProps = {
  label: "",
  title: "",
  placeholderMessage: "",
  onChange: () => {},
  validateForm: () => {},
  onFocusElement: () => {},
  errors: [],
  marginTop: [],
};

export default Title;
